import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { KAvatar, KIcon } from "@kyburz/kdesign-system";
import { clearUser } from "../../redux/actions/actions";
import MainMenu from "./MainMenu";
import KTabs from "../ui/tabs/KTabs";
import { TabInterface } from "../../interfaces/tab-interface";
import "./Header.css";
import { RootStateInterface } from "../../interfaces/ReduxInterface";

interface Props {
  title: string;
  handleArrowClick?: () => void | any;
  tabs?: TabInterface[] | undefined;
  handleTabChange?: (v?, v1?) => void | undefined;
  activeTab?: string | number;
}

const Header: React.FC<Props> = ({
  title,
  handleArrowClick = undefined,
  tabs = undefined,
  handleTabChange = undefined,
  activeTab = undefined,
}: Props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector(
    (state: RootStateInterface) => state.user.currentUser,
  );

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = () => {
    document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    localStorage.removeItem("region");
    localStorage.removeItem("refresh_token");
    dispatch(clearUser());
  };

  const mainMenu = (
    <MainMenu
      items={[
        { label: "Settings", action: () => history.push("/settings/general") },
        { label: "Logout", action: handleLogout },
      ]}
    />
  );

  return (
    <header className="header__background">
      <div className="header__title-block">
        {handleArrowClick !== undefined && (
          <span className="header__title-backarrow">
            <KIcon
              icon="arrow-left"
              size={24}
              color="#383F51"
              onClick={() => handleArrowClick()}
            />
          </span>
        )}
        {tabs === undefined ? (
          <div className="header__title-header-no-tabs">
            <h1>{title}</h1>
          </div>
        ) : (
          <div className="header__title-header-tabs">
            <h1>{title}</h1>
            <KTabs
              tabs={tabs}
              // @ts-ignore
              handleChange={handleTabChange}
              activeTab={activeTab}
            />
          </div>
        )}
      </div>
      <div className="header__navigation-block">
        <div onClick={() => setIsMenuOpen(!isMenuOpen)}>
          <KAvatar
            firstName={user.first_name}
            lastName={user.last_name}
            avatar={user.avatar}
          />
        </div>
      </div>
      {isMenuOpen && mainMenu}
    </header>
  );
};

export default Header;
